import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";

import Analytics from "../../../../../../helpers/analytics";
import { Mixpanel } from "../../../../../../components/shared/Mixpanel";

function ContactUs(props) {
  const { video, location, onCancel } = props;

  return (
    <Link
      className={`contact--us ${props.className}`}
      to={{
        pathname: "/licensing/inquiry",
        state: {
          videos: [video],
          lead: "LP - Custom Rights Package Inquiry"
        }
      }}
      onClick={() => {
        if (onCancel) {
          onCancel();
        }
        localStorage.setItem("prevPath", location.pathname);
        Mixpanel.track("Custom rights package", {
          JVID: video.jmId,
          "Video Title": video.title
        });
        Analytics.track("Contact Us", {
          category: "LP-VideoDetail",
          label: video.jmId
        });
      }}
    >
      <Button variant="outlined">Contact Us</Button>
    </Link>
  );
}

export default ContactUs;
